module.exports = __webpack_public_path__ + "img/trash-solid.aecef536.png";